import {
  ACTOR_FILTER_VALUES,
  EVAL_FILTER_VALUES,
  HUMAN_FEEDBACK_FILTER_VALUES,
  STATUS_FILTER_VALUES,
} from '@/pages/AgentTrace/filters';
import { RecentTraces } from '@/pages/AgentTrace/RecentTraces';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { z } from 'zod';

const AgentTraceSearchSchema = z.object({
  status: z.enum(STATUS_FILTER_VALUES).optional(),
  name: z.string().min(1).optional(),
  model: z.string().min(1).optional(),
  evalVerdict: z.enum(EVAL_FILTER_VALUES).optional(),
  humanFeedback: z.enum(HUMAN_FEEDBACK_FILTER_VALUES).optional(),
  triggerActor: z.enum(ACTOR_FILTER_VALUES).optional(),
  patientId: z.string().min(1).optional(),
  patientMedplumId: z.string().min(1).optional(),
  patientLabel: z.string().min(1).optional(),
});

const RouteComponent = (): React.ReactNode => {
  // oxlint-disable-next-line no-use-before-define
  const filters = Route.useSearch();
  // oxlint-disable-next-line no-use-before-define
  const navigate = useNavigate({ from: Route.fullPath });

  return (
    <RecentTraces
      filters={filters}
      onFilterChange={(patch) => {
        // `replace` keeps rapid filter tweaks from flooding the history stack.
        void navigate({ search: (prev) => ({ ...prev, ...patch }), replace: true });
      }}
    />
  );
};

export const Route = createFileRoute('/_auth/internal/agent-trace/')({
  component: RouteComponent,
  loader: () => ({ crumb: 'AI workflows' }),
  validateSearch: AgentTraceSearchSchema,
});
